import { render, staticRenderFns } from "./games-list.vue?vue&type=template&id=2d3991cb&scoped=true"
import script from "./games-list.vue?vue&type=script&lang=js"
export * from "./games-list.vue?vue&type=script&lang=js"
import style0 from "./games-list.vue?vue&type=style&index=0&id=2d3991cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3991cb",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/games-list.vue
// module id = 0hpB
// module chunks = 0